import { Dispatch } from "redux";
import {
    apiRequest, APIResponse, APIServiceBase,
    dispatchAuthAction, dispatchIfAvailable, getApiUrl, getEnvConfig, HTTPStatus, logger, resetRedux, safeRedirect
} from "kmstack-shared";
import { RegisterFormWithIp } from "../schemas/auth.schema";
import { AuthProviderEnum, LoginForm } from "@/types/types";

export class AuthService extends APIServiceBase {
    static async amILoggedIn(dispatch?: Dispatch): Promise<boolean> {
        let res = await apiRequest('/auth/am-i-authenticated');

        let response = res.status === HTTPStatus.OK;
        if (res.status === HTTPStatus.OK) {
            dispatchIfAvailable(dispatchAuthAction(true), dispatch);
        } else {
            dispatchIfAvailable(resetRedux(), dispatch);
        }
        return response
    }
    // TODO: login with google broken fix me
    static async signup(data: RegisterFormWithIp, provider: AuthProviderEnum): Promise<APIResponse> {
        return apiRequest(`/auth/signup/${ provider }`, 'POST', data);
    }

    static async login(data: LoginForm, provider: AuthProviderEnum): Promise<APIResponse> {
        return apiRequest(`/auth/login/${ provider }`, 'POST', data);
    }

    static async redirectAfterLogin(provider: AuthProviderEnum): Promise<APIResponse> {
        return apiRequest(`/auth/redirect-after-login/${ provider }`);
    }

    static async redirectOnLogin(provider: AuthProviderEnum): Promise<APIResponse> {
        return apiRequest(`/auth/redirect-on-login/${ provider }`);
    }

    static async linkOauthProviderOrVerify(verify: boolean = true, linking_url_token: string): Promise<APIResponse> {
        var path = '/auth/link-oauth-provider';
        if (verify) {
            path = path + '/verify/' + linking_url_token;
        } else {
            path = path + '?linking_url_token=' + linking_url_token;
        }
        return apiRequest(path)
    }

    static async logout(dispatch?: Dispatch): Promise<APIResponse> {
        const res = await apiRequest('/auth/logout');
        if (res.status === HTTPStatus.OK) {
            dispatchIfAvailable(resetRedux(), dispatch);
        }
        return res
    }

    static redirectOnServer(provider: AuthProviderEnum) {
        const url = getApiUrl(`/auth/login/${ provider }`);
        window.location.href = url;
    }

    static redirectOnClient(path?: string): boolean {
        // Use environment variable for dashboard URL
        const envConfig = getEnvConfig();
        const baseDashBoard = envConfig.dashboardUrl;

        let redirectTo: string | undefined;

        if (path) {
            redirectTo = path;
        } else {
            // Prioritize return_to query param for cross-origin deep linking
            const searchParams = new URLSearchParams(window.location.search);
            redirectTo = searchParams.get('return_to')
                || localStorage.getItem('postLoginRedirect') // Fallback for same-domain
                || localStorage.getItem('redirectTo')
                || baseDashBoard;
        }

        // Validate and sanitize the redirect URL
        // safeRedirect prevents open redirects and validates host against allowedHosts
        // If the URL is invalid or unsafe, it returns baseDashBoard (as passed in 2nd arg) or default '/account'
        const finalUrl = safeRedirect(redirectTo, baseDashBoard, { allowedHosts: envConfig.allowedHosts });

        if (!finalUrl) return false;

        // Prevent redirect loop checks
        // Resolve relative paths to absolute for comparison
        const targetUrl = finalUrl.startsWith('/')
            ? new URL(finalUrl, window.location.origin).href
            : finalUrl;

        if (targetUrl === window.location.href) {
            return false;
        }

        // Cleanup storage to start fresh
        localStorage.removeItem('postLoginRedirect');
        localStorage.removeItem('redirectTo');

        window.location.href = finalUrl;
        return true;
    }

    static async switchOrganization(orgId: string): Promise<APIResponse> {
        logger.dev('Switching organization to:', orgId);
        return apiRequest('/auth/switch-organization', 'POST', { org_id: orgId });
    }

    static call(path: string, method?: string, data?: any): Promise<APIResponse> {
        return apiRequest(path, method, data);
    }

}

export class DataService extends APIServiceBase {

    static call(path: string, method?: string, data?: any): Promise<APIResponse> {
        return apiRequest(path, method, data);
    }

    static fetchStaticData(endPoint: string, extraParams?: any): Promise<APIResponse> {
        var _endpoint = '/static-data/' + endPoint
        if (extraParams) {
            _endpoint = _endpoint + extraParams
        }
        logger.dev('Fetching static data:', _endpoint);
        return DataService.call(_endpoint)
    }

}
